import React, { useRef, useState, useEffect } from "react";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import Papa from "papaparse";
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import CustomPagination from "components/CustomPagination";
import { getItemsByPage, downloadFileAttachment } from "utils/util";
import {LoadingSpinner} from "../../components/Icons";
import { PERMISSIONS, IMPORT_JOB } from '../../constants/index';
import {
  importJobTemp,
  deleteJobTemp,
  importAllTempToJob,
  setError,
  setSuccess,
  setSavedCSV,
  setPublishedCSV,
  importPublicAllTempToJob,
  updatePublicAllTempToJob,
  setActionStatus,
  setListImportError,
  setListImportSuccess,
  setCurrentPageSuccess,
  setCurrentPageError,
  setFile,
  publicJobRecord,
  publicJobRecordWithSave,
  setLoading,
  setActionName,
} from "../../reducers/companyJob";
import ReturnButton from "../../components/ReturnButton";
import CustomButton from "../../components/CustomButton";
import * as Encoding from 'encoding-japanese';
import Copyright from "../../components/Copyright";
import i18n from 'i18next';

const errorTableHeaders = ["行", "列", "ステータス", "エラー内容"];
const headers = ["タイトル", "職種", "形態"];
const headerField = [
  {label: "求人タイトル", field: "title"},
  {label: "タレント種別", field: "talent_type"},
  {label: "タレントタグ", field: "talent_tag"},
  {label: "タレントタグ結合条件", field: "tag_logic"},
  {label: "職種１", field: "occupation_1"},
  {label: "職種２", field: "occupation_2"},
  {label: "職種３", field: "occupation_3"},
  {label: "業種１", field: "industry_1"},
  {label: "業種２", field: "industry_2"},
  {label: "業種３", field: "industry_3"},
  {label: "都道府県", field: "location_city"},
  {label: "市区町村", field: "location_village"},
  {label: "番地・ビル名", field: "location_building"},
  {label: "最寄り駅", field: "location_station"},
  {label: "勤務地変更の範囲", field: "location_note"},
  {label: "年収", field: "annual_salary_min_max"},
  {label: "役職", field: "role"},
  {label: "部署", field: "department"},
  {label: "メッセージ", field: "message_from_department"},
  {label: "受動喫煙対策", field: "void_smoking_policy"},
  {label: "保険待遇", field: "insurance_option"},
  {label: "保険待遇備考", field: "insurance_note"},
  {label: "諸手当", field: "bonus_option"},
  {label: "諸手当備考", field: "bonus_note"},
  {label: "休日休暇", field: "days_off_pattern"},
  {label: "休日休暇備考", field: "working_off_days_note"},
  {label: "年間休日", field: "annual_working_off_day"},
  {label: "雇用形態", field: "type"},
  {label: "雇用形態備考", field: "type_note"},
  {label: "勤務形態", field: "working_style"},
  {label: "勤務時間", field: "working_hour_from_to"},
  {label: "休憩時間", field: "break_time"},
  {label: "平均残業時間", field: "monthly_average_ot_hours"},
  {label: "固定残業代", field: "fixed_OT_payment"},
  {label: "残業代備考", field: "fixed_OT_payment_note"},
  {label: "採用人数", field: "persons_to_hire"},
  {label: "給与形態", field: "salary_payment_method"},
  {label: "月額", field: "monthly_salary_min_max"},
  {label: "賞与", field: "bonuses_per_year"},
  {label: "昇給", field: "has_salary_increment"},
  {label: "賃金備考", field: "wage_note"},
  {label: "試用期間", field: "probation_duration"},
  {label: "試用期間月数", field: "probation_months"},
  {label: "選考の流れ", field: "selection_process"},
  {label: "職務内容", field: "description"},
  {label: "変更の範囲有無", field: "is_change_scope"},
  {label: "変更の範囲", field: "change_scope"},
  {label: "希望年齢", field: "applicant_age_min_max"},
  {label: "タグ", field: "tag"},
  {label: "募集ステータス", field: "status"},
  {label: "募集終了日", field: "expiry_date"},
  {label: "その他特記事項（管理用）", field: "admin_note"},
]

const JobCSV = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isOver, setIsOver] = useState(false);
  const [fileLoaded, setFileLoaded] = useState(false);
  const [fileDecodedString, setFileDecodedString] = useState(null);
  const fileRef = useRef<any>(null);
  const navigate = useNavigate();
  const [errorTable, setErrorTable] = useState<any>([]);
  const [errorLoaded, setErrorLoaded] = useState(false);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const currentUser = useSelector((state: any) => state.currentUser);
  const { staffPermission } = currentUser;
  const {
    loading,
    success,
    error,
    savedCSV,
    publishedCSV,
    resultImport,
    listImportSuccess,
    listImportError,
    actionStatus,
    actionName,
    currentPageSuccess,
    currentPageError,
    pageSize,
    file,
  } = useSelector((state: any) => state.companyJob);
  //Access to this page is denied
  if(!staffPermission[PERMISSIONS.JOB_NEW]) {
    return null;
  }
  
  const [tableData, setTableData] = useState<any>([]);
  const handleChangeFile = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      const fileUpload = e.target.files[0];
      validateFileUpload(fileUpload);
    }
    e.target.value = '';
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    if (loading) return;
    setIsOver(true);
  };

  const handleDragLeave = (e: any) => {
    e.preventDefault();
    if (loading) return;
    setIsOver(false);
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    if (loading) return;
    setIsOver(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      validateFileUpload(droppedFile);
    }
  };

  const handleClick = () => {
    if (loading) return;
    fileRef.current.click()
  }
  
  const validateFileUpload = (fileUpload: any) => {
    const allowedExtensions = ['csv'];
    const fileExtension = fileUpload.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      showToast('メッセージ', i18n.t('MSG_JOB_SELECT_FILE_CSV_FORMAT'), 'error');
      return;
    }
  
    if (fileUpload.size > IMPORT_JOB.MAX_FILE_SIZE) {
      showToast('メッセージ', i18n.t('MSG_JOB_MAX_FILE_SIZE'), 'error');
      return;
    }
    
    return detectedEncoding(fileUpload);
  };

  const handleCancelImport = () => {
    dispatch(setLoading(true));
    setTableData([]);
    dispatch(setFile(null));
    setFileLoaded(false);
    setErrorLoaded(false);
    setErrorTable([])
    dispatch(setLoading(false));
    setFileDecodedString(null);
  };

  const handleFileUpload = async () => {
    setErrorLoaded(false);
    dispatch(setLoading(true));
    if (file && fileDecodedString) {
      const fileType = file.name.split(".").pop();
      if (fileType != "csv") {
        handleError(i18n.t('MSG_JOB_SELECT_FILE_CSV_FORMAT'));
        return;
      } 
      
      handleFileCSV(file);
    }
    dispatch(setLoading(false));
  };

  const validateCSVHeader = (csvItem: any) => {
    if (!csvItem || csvItem.length === 0) return false;
    const csvHeaders = Object.keys(csvItem[0]);
  
    if (csvHeaders.length !== headerField.length) return false;
  
    const isValid = headerField.every((field) => csvHeaders.includes(field.label));
  
    return isValid;
  };

  const handleFileCSV = (file) => {
    const reader = new FileReader();
  
    reader.onload = async (event) => {
        const decodedString = fileDecodedString;
        if(!decodedString) {
          handleError(i18n.t('MSG_GLOBAL_DATA_INCORRECT_FORMAT'));
          return;
        }

        Papa.parse(decodedString, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
              if (results.data.length > 0) {
                // Validate header 
                const validateHeaderFlag = validateCSVHeader(results.data)
                if(!validateHeaderFlag) {
                  handleError(i18n.t('MSG_GLOBAL_DATA_INCORRECT_FORMAT'));
                  return;
                }

                const formattedData = results.data.filter(row => 
                  Object.values(row).some(value => value && value.trim() !== '')
                ).map(row => {
                  const newObj = {};
                  Object.keys(row).forEach(key => {
                      const header = headerField.find(h => h.label === key);
                      if (header) {
                          newObj[header.field] = row[key];
                      }
                  });

                  return newObj;
                });

                const data = { requestBody: { data: formattedData } };
                dispatch(importJobTemp(data));
                setFileDecodedString(null);
              } else {
                handleError(i18n.t('MSG_JOB_NO_DATA_IMPORT'));
              }
          },
        });
    };

    reader.readAsArrayBuffer(file);
  };

  const detectedEncoding = (file) => {
    const reader = new FileReader();
  
    reader.onload = () => {
      const buffer = new Uint8Array(reader.result);
      const encoding = Encoding.detect(buffer);
  
      if (encoding === "UTF8" || encoding === "SJIS") {
        let decodedString = "";
  
        if (encoding === "UTF8") {
          decodedString = new TextDecoder("utf-8").decode(buffer);
        } else if (encoding === "SJIS") {
          decodedString = Encoding.convert(buffer, {
            to: "UNICODE",
            from: "SJIS",
            type: "string",
          });
        }
  
        dispatch(setFile(file));
        setFileDecodedString(decodedString);
      } else {
        showToast('メッセージ', i18n.t('MSG_GLOBAL_DATA_INCORRECT_FORMAT'), 'error');
      }
    };
  
    reader.readAsArrayBuffer(file);
  };  

  const handleChooseNewFile = () => {
    dispatch(setActionName('handleChooseNewFile'));
    handleCancelImport();
    fileRef.current.click();
  }

  const handleImportAll = (e: any) => {
    e.preventDefault();
    const data = {
      requestBody: resultImport.success_rows,
    }
    dispatch(importAllTempToJob(data));
    dispatch(setSavedCSV(true))
  };

  const handlePublicAll = (e: any) => {
    e.preventDefault();
    if(savedCSV){
      const ids = resultImport.success_rows.map((item: any) => item.id);
      const idsString = ids.join(',');
      const data = {
        ids: idsString,
        requestBody: resultImport.success_rows,
      }
      dispatch(updatePublicAllTempToJob(data));
    }
    else{
      const data = {
        requestBody: resultImport.success_rows,
      }
      dispatch(importPublicAllTempToJob(data));
    }
    dispatch(setPublishedCSV(true))
  };

  const showToast = (title: string, message: string, variant: string, type="normal") => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} type={type} />
      ),
    });
  };

  const handleError = (mess: any) => {
    showToast('メッセージ', mess, 'error');
    dispatch(setFile(null));
    setFileLoaded(false);
  }; 

  useEffect(() => {
    if (Object.keys(resultImport).length === 0) {
      handleCancelImport();
      return;
    }
    
    if(listImportSuccess.length > 0){
      setTableData(listImportSuccess);
      setFileLoaded(true);
    }
    else if(listImportError.length > 0){
      const data = listImportError.map((item: any) => {
        return {
          row: item.row_index,
          column: item.column,
          status: item.status,
          errorText: item.error_message
        };
      });
      setErrorLoaded(true);
      setErrorTable(data);
      setFileLoaded(true);
    }
    else{
      handleCancelImport();
      return;
    }

    if(resultImport?.success_rows){
      const await_public_record = resultImport.success_rows.filter((record: any) => !record.hasOwnProperty('is_disable_public_button') || record.is_disable_public_button === false);
      if(await_public_record.length === 0) dispatch(setPublishedCSV(true));
    }
  }, [resultImport, listImportError, listImportSuccess]);

  //show toast from reducers
  useEffect(() => {
    if (actionStatus === 'fulfilled' && actionName === 'importJobTemp') {
      if(listImportSuccess.length > 0) {
        showToast('アップロードが完了しました',`${file?.name} の読み込みが完了しました。`, "success", "display_title");
        dispatch(setSuccess(null));
      }
    }
    if (actionStatus === 'rejected' && actionName === 'importJobTemp') {
      setErrorLoaded(true);      
      dispatch(setError(null));
    }
    dispatch(setActionStatus('idle'));
  }, [actionStatus, actionName]);
  useEffect(() => {
    if(success){
      showToast('メッセージ', success, "success");
      dispatch(setSuccess(null));
    }
    else if(error){
      showToast('メッセージ', error, "error");
      dispatch(setError(null));
    }
  }, [error, success]);

  const handleDeleteJobTemp = (id: any) => {
    if(savedCSV || publishedCSV) return;
    else{
      const data = {
        id: Number(id),
      }
      dispatch(deleteJobTemp(data));
    }
  }

  const handleDownloadTemplate = async () => {
    const currentRootUrl = window.location.origin;
    const fileUrl = currentRootUrl + "/static/sample-import/Template_JobRegistration.csv";

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("File not found");

      const buffer = await response.arrayBuffer();
      const uint8ArrayRaw = new Uint8Array(buffer);
      const detectedEncoding = Encoding.detect(uint8ArrayRaw);
      let downloadBytes = uint8ArrayRaw;
      let mimeType = "text/csv;charset=UTF-8";

      if (detectedEncoding === 'UTF8') {
        const sjisDataArray = Encoding.convert(uint8ArrayRaw, { to: 'SJIS', from: 'UTF8', type: 'array' });
        downloadBytes = new Uint8Array(sjisDataArray);
        mimeType = "text/csv;charset=Shift_JIS";
      } else if (detectedEncoding === 'SJIS') {
        mimeType = "text/csv;charset=Shift_JIS";
      }

      const blob = new Blob([downloadBytes], { type: mimeType });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = "Template_JobRegistration.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (e) {
      console.error(e);
    }
  };

  const handleDownloadGuide = async () => {
    const currentRootUrl = window.location.origin;
    const fileUrl = currentRootUrl + "/static/sample-import/Guide_JobRegistrationCSV.xlsx";

    try {
      await downloadFileAttachment(fileUrl, "Guide_JobRegistrationCSV.xlsx");
    } catch (e) {
      console.error(e);
    }
  };

  const onPageChangeError = (pageNumber: any) => {
    dispatch(setCurrentPageError(pageNumber));
    const listErrorPaging = getItemsByPage(resultImport.fail_rows, pageNumber, pageSize);
    dispatch(setListImportError(listErrorPaging));
  };
  const onPageChangeSuccess = (pageNumber: any) => {
    dispatch(setCurrentPageSuccess(pageNumber));
    const listSuccessPaging = getItemsByPage(resultImport.success_rows, pageNumber, pageSize);
    dispatch(setListImportSuccess(listSuccessPaging));
  };

  const handlePublicJobRecord = (jobID: any) => {
    const jobRecord = resultImport.success_rows.find((item: any) => item.id === jobID);
    if(jobRecord.updated_by){ //has been saved to tbl.job
      const data = {
        id: jobRecord.id,
        requestBody: {
          ...jobRecord,
          is_public: true,
        },
      }
      dispatch(publicJobRecord(data));
    }
    else{
     const data = {
        id: jobRecord.id,
        requestBody: jobRecord,
      }
      dispatch(publicJobRecordWithSave(data));
    }
  }

  const handleClickItemImport = (data: any) => {
    if (!data.updated_by) {
      navigate("/company/job/preview-temp/" + data.id);
      return;
    }
    navigate(data.is_public ? "/company/job/detail/" + data.id : "/company/job/preview/" + data.id);
  }

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <div className="mb-6 flex items-center gap-4">
            <ReturnButton onClick={() => navigate('/company/job', { state: { isFromDetail: true } })} />
            <span className="text-sm alu-text-base-1">/</span>
            <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
              CSV 一括アップロード
            </h3>
          </div>

          <p className="text-sm alu-text-base-1 mb-6">
            求人情報をCSV形式で一括アップロードします。
          </p>

          <div className="mb-6">
            <CustomButton
              variant="outline"
              size="sm"
              isCombo={true}
              comboButtons={[
                  {name: "求人登録CSVテンプレート", onClick: handleDownloadTemplate},
                  {name: "求人CSV作成ガイド", onClick: handleDownloadGuide}
              ]}
            >
              （テンプレートをダウンロード）
            </CustomButton>
          </div>

          <div className="bg-white rounded-lg p-6">
            <input
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/*"
              onChange={handleChangeFile}
              type="file"
              className="hidden"
              ref={fileRef}
              disabled={loading}
            />
            {!file && (
              <div className="relative w-[100%] h-[18.75rem]">
                <div className="w-full absolute top-0 left-0">
                  <div
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={handleClick}
                    className={`hover:cursor-pointer hover:bg-[#FFF3E5] hover:border-[#FF861A] rounded-lg w-full h-[18.75rem] ${
                      isOver ? "bg-[#009CF2]" : "bg-white"
                    } border border-dashed border-[#E0E0E0] flex flex-col gap-4 items-center justify-center`}
                  >
                    <button>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_10995_14344)">
                          <path
                            d="M12.0003 21.3333H20.0003V13.3333H25.3337L16.0003 4L6.66699 13.3333H12.0003V21.3333ZM6.66699 24H25.3337V26.6667H6.66699V24Z"
                            fill={`${isOver ? "#fff" : "#808080"}`}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_10995_14344">
                            <rect width="32" height="32" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                    <p
                      className={`text-sm leading-[1.3125rem] ${
                        isOver ? "text-white" : "alu-text-base-1"
                      } text-center`}
                    >
                      ここにCSVファイルをドラッグ&ドロップ、または
                      <br />
                      <span className="text-[#FF861A]">ファイルを選択する</span>
                    </p>
                  </div>
                </div>
              </div>
            )}

            {file && (
              <>
                <div
                  className={`${!file && "mt-4"} mb-[0.625rem] ${
                    !fileLoaded ? "px-4 py-2" : ""
                  } flex items-center gap-4 rounded-lg ${
                    !fileLoaded ? "border" : ""
                  } border-[#E0E0E0]`}
                >
                  <p
                    className={`${!fileLoaded ? "text-base" : "text-sm"} ${
                      !errorLoaded ? "alu-text-base-2" : "text-[#F33D62]"
                    } font-bold`}
                  >
                    {file.name}
                  </p>
                  <p
                    className={`text-sm ${
                      !fileLoaded
                        ? "alu-text-base-1"
                        : !errorLoaded
                        ? "alu-text-base-2"
                        : "text-[#F33D62]"
                    }`}
                  >
                    {!fileLoaded
                      ? `${loading ? "を読み込んでいます。" : "ファイルが選択されました"}`
                      : !errorLoaded
                      ? `を読み込みました。以下の ${resultImport?.success_rows?.length} 件の求人を一括公開、または個別に公開できます。`
                      : "の読込中にエラーが発生しました。"}
                  </p>
                </div>
                {!fileLoaded && (
                  <div className="flex items-center gap-4">
                    <CustomButton
                      disabled={loading}
                      onClick={handleFileUpload}
                      type="button"
                      size="md"
                    >
                      <p>{loading ? "送信中..." : "CSV を登録"}</p>
                      {loading && (
                        <span><LoadingSpinner /></span>
                      )}
                    </CustomButton>
                    <CustomButton size="md" onClick={() => navigate('/company/job')} type="button" variant="outline">
                      キャンセル
                    </CustomButton>
                    <CustomButton size="md" onClick={() => dispatch(setFile(null))} type="button" variant="outline">
                      別のファイルを選択する
                    </CustomButton>
                  </div>
                )}

                {(!errorLoaded && tableData.length > 0) && (
                  <>
                  <table className="table-auto w-full mb-4">
                    <thead className="border-b alu-border px-4 py-2">
                      <tr>
                        {headers.map((header: any, idx: any) => (
                          <th key={idx} className="px-4 py-2 text-left">
                            <div className="flex items-center">
                              <p className="font-normal text-sm leading-[1.3125] alu-text-base-1">
                                {header}
                              </p>
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((data: any, idx: any) => (
                        <tr key={idx} className={`border-b border-b-[#E0E0E0] hover:bg-[#fff3e5]`}>
                          <td key={idx} className="px-4 py-2">
                            <p className="alu-text-base-2 text-left font-normal text-sm leading-[1.3125rem]">
                              {data.title}
                            </p>
                            {data.is_disable_public_button && (
                            <p className="flex items-center text-sm alu-text-base-1 leading-[1.3125rem]">
                              <span className="mr-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="13"
                                  viewBox="0 0 12 13"
                                  fill="none"
                                >
                                  <circle
                                    cx="6"
                                    cy="6.5"
                                    r="6"
                                    fill="#FFC700"
                                  />
                                </svg>
                              </span>
                              公開
                            </p>
                            )}
                          </td>
                          <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125rem] alu-text-base-2">
                            {data.occupation_2.name}
                          </td>
                          <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125rem] alu-text-base-2">
                            {data.type.label}
                          </td>
                          <td className="px-4 py-2 text-center font-normal text-sm leading-[1.3125rem] alu-text-title">
                            <span
                              className="hover:cursor-pointer"
                              onClick={() => handleClickItemImport(data)}
                            >
                              表示
                            </span>
                          </td>
                          <td className="px-4 py-2 text-center font-normal text-sm leading-[1.3125rem] alu-text-title">
                            {data.is_disable_public_button ? (<span className="text-[#BBB]">公開</span>) : (<span className="hover:cursor-pointer" onClick={(e: any) => {e.preventDefault(); handlePublicJobRecord(data.id)}}>公開</span>)}
                          </td>
                          <td className="px-4 py-2 text-center font-normal text-sm leading-[1.3125rem]">
                            {data.is_disable_public_button ?
                              <>
                                <div className="inline-flex items-center justify-center text-[#BBB]">
                                  <span className="mr-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                                        fill="#BBB"
                                      />
                                    </svg>
                                  </span>
                                  削除
                                </div>
                              </> :
                              <>
                                <div
                                  onClick={(e: any) => {e.preventDefault(); handleDeleteJobTemp(data.id)}}
                                  className={`inline-flex items-center justify-center ${savedCSV || publishedCSV ? "text-[#BBB]" : "alu-text-title hover:cursor-pointer"}`}
                                >
                                  <span className="mr-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                                        fill={`${savedCSV || publishedCSV ? "#BBB" : "#FF861A"}`}
                                      />
                                    </svg>
                                  </span>
                                  削除
                                </div>
                              </>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {resultImport?.success_rows?.length && resultImport?.success_rows?.length > pageSize && (
                  <div className="flex items-center justify-center mb-10">
                    <CustomPagination total={resultImport?.success_rows?.length} currentPage={currentPageSuccess} pageSize={pageSize} onPageChange={onPageChangeSuccess}/>
                  </div>
                  )}
                  </>
                )}
                {(errorLoaded && errorTable.length > 0) && (
                  <>
                  <table className="table-auto w-full mb-4">
                    <thead className="border-b alu-border px-4 py-2">
                      <tr>
                        {errorTableHeaders.map((header, idx) => (
                          <th key={idx} className="px-4 py-2 text-left">
                            <div className="flex items-center">
                              <p className="font-normal text-sm leading-[1.3125] alu-text-base-1">
                                {header}
                              </p>
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {errorTable.map((data: any, idx: any) => (
                        <tr key={idx} className={`border-b border-b-[#E0E0E0] hover:bg-[#fff3e5]`}>
                          <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                            {data.row}
                          </td>
                          <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                            {data.column}
                          </td>
                          <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                            {data.status}
                          </td>
                          <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                            {data.errorText}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {resultImport?.fail_rows?.length && resultImport?.fail_rows?.length > pageSize && (
                  <div className="flex items-center justify-center mb-10">
                    <CustomPagination total={resultImport?.fail_rows?.length} currentPage={currentPageError} pageSize={pageSize} onPageChange={onPageChangeError}/>
                  </div>
                  )}
                  </>
                )}

                {fileLoaded && !errorLoaded && (
                  <div className="flex items-center gap-4">
                    <CustomButton
                      type="button"
                      variant="outline"
                      size="md"
                      onClick={(e: any) => handleImportAll(e)}
                      disabled={savedCSV || publishedCSV || (loading && actionName === "importAllTempToJob")}
                    >
                      <p>{loading && actionName == "importAllTempToJob" ? "保存中..." : "設定したステータスで登録"}</p>
                      {loading && actionName == "importAllTempToJob" && (
                        <span><LoadingSpinner /></span>
                      )}
                    </CustomButton>
                    <CustomButton
                      type="button"
                      size="md"
                      onClick={(e: any) => handlePublicAll(e)}
                      disabled={publishedCSV || (loading && (actionName == "importPublicAllTempToJob" || actionName == "updatePublicAllTempToJob"))}
                    >
                      <p>{loading && (actionName == "importPublicAllTempToJob" || actionName == "updatePublicAllTempToJob") ? "保存中..." : "一括公開"}</p>
                      {loading && (actionName == "importPublicAllTempToJob" || actionName == "updatePublicAllTempToJob") && (
                        <span><LoadingSpinner /></span>
                      )}
                    </CustomButton>
                  </div>
                )}

                {fileLoaded && errorLoaded && (
                  <div className="flex items-center gap-4">
                    <CustomButton
                      type="button"
                      variant="text"
                      onClick = {handleCancelImport}
                      disabled={loading}
                    >
                      <p>{loading ? "処理中..." : "読み込みをキャンセル"}</p>
                      {loading && (
                        <span><LoadingSpinner /></span>
                      )}
                    </CustomButton>
                    <CustomButton
                      type="button"
                      size="md"
                      onClick={handleChooseNewFile}
                      disabled={loading || actionName == "handleChooseNewFile"}
                    >
                      <p>{loading && actionName == "handleChooseNewFile" ? "処理中..." : "ファイルを指定し直す"}</p>
                      {loading && actionName == "handleChooseNewFile" && (
                        <span><LoadingSpinner /></span>
                      )}
                    </CustomButton>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Copyright view="company" />
    </>
  );
};

export default JobCSV;
